import React from 'react';
import ImagemLoading from 'assets/img/loading_eSefaz.gif';
import { getEnv } from 'config/enviroment';
import { USUARIO_LOGADO_FAS } from 'utils/consts';
import * as S from './styles';

export default function PageAutenticacao() {
  const env = getEnv();

  React.useEffect(() => {
    sessionStorage.removeItem(USUARIO_LOGADO_FAS);
  }, []);

  return (
    <S.Contain>
      <S.ContainerImagem>
        <img src={ImagemLoading} alt={'Carregando'} onClick={() => window.open(env?.OIDC_AUTHORIY)} />
      </S.ContainerImagem>
      <S.Texto>Verificando autenticação</S.Texto>
      <S.SubTexto>Aguarde...</S.SubTexto>
    </S.Contain>
  );
}
